import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        footer: {
            border: '1px solid #dadce0',
            boxSizing: 'border-box',
            height: 34,
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 300,
            fontSize: '14px',
            lineHeight: '16px',
            color: '#4F4F4F',
            width: '100%',
            background: '#ffffff',
            minHeight: 34,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
    }),
);
